import { RoadmapCard } from "@config";
import {
  useGetDevice,
  useGetDocuments,
  useGetDocumentsTemplates,
  useGetTaskStates,
  useGetTasks,
  useGetUser,
} from "@hooks";
import { Skeleton } from "@mui/material";
import { meetsVisibilityConditions } from "@utils";
import { useParams } from "react-router-dom";
import { TaskAccordion } from "src/components/Roadmap/Task/TaskAccordion";

type Props = {
  cardConfig: { card: RoadmapCard; stageKey: string };
  open: boolean;
};

export const TaskContent = ({ cardConfig }: Props) => {
  const { data: user } = useGetUser();
  const { orgId = "", deviceId = "" } = useParams();
  const { data: templatesConfig } = useGetDocumentsTemplates({
    orgId,
    deviceId,
  });
  const { data: documents } = useGetDocuments(orgId, deviceId);
  const { data: device } = useGetDevice({ orgId, deviceId });
  const { data: tasks } = useGetTasks(orgId, deviceId);
  const { data: taskStates } = useGetTaskStates({
    orgId,
    deviceId,
    enabled: !!orgId && !!deviceId,
  });

  if (documents && user && device && tasks && templatesConfig) {
    return tasks
      .filter((task) => {
        return (
          task.parentCardKey === cardConfig.card.cardKey &&
          meetsVisibilityConditions(
            task.visibilityConditions,
            device,
            documents
          )
        );
      })
      .map((task) => (
        <TaskAccordion
          key={task.taskKey}
          task={task}
          documents={documents}
          user={user}
          device={device}
          deviceId={deviceId}
          templatesConfig={templatesConfig!}
          tasks={tasks}
          taskStates={taskStates}
        />
      ));
  }

  return (
    <>
      <Skeleton
        variant="rectangular"
        key={0}
        width="100%"
        height={28}
        className="mb-2"
      />
      <Skeleton
        variant="rectangular"
        key={1}
        width="90%"
        height={28}
        className="mb-2"
      />
      <Skeleton
        variant="rectangular"
        key={2}
        width="100%"
        height={28}
        className="mb-2"
      />
    </>
  );
};
